<template>
  <div
    class="org-settings-hub"
    :class="`org-settings-hub--${variant}`"
  >
    <header v-if="variant !== 'page'" class="org-settings-hub__header">
      <div class="org-settings-hub__header-text">
        <h2 class="org-settings-hub__title">{{ title }}</h2>
        <p v-if="subtitle" class="org-settings-hub__subtitle">{{ subtitle }}</p>
      </div>
      <div class="org-settings-hub__search">
        <SwSearchField
          :model-value="search"
          placeholder="Search settings"
          clearable
          @update:model-value="$emit('update:search', $event)"
        />
      </div>
    </header>

    <div v-if="filteredCategories.length" class="org-settings-hub__grid">
      <button
        v-for="category in filteredCategories"
        :key="category.id"
        type="button"
        class="org-settings-hub__tile"
        :class="{ 'org-settings-hub__tile--active': category.id === activeId }"
        @click="$emit('select', category.id)"
      >
        <div class="org-settings-hub__tile-top">
          <span
            class="org-settings-hub__tile-icon"
            :class="`org-settings-hub__tile-icon--${category.accent}`"
          >
            <v-icon :icon="category.icon" size="20" />
          </span>
          <span
            v-if="resolvedShowStatusChips"
            class="sw-status-chip"
            :class="
              category.configured
                ? 'sw-status-chip--success'
                : 'sw-status-chip--neutral'
            "
          >
            <span class="sw-status-chip__dot" aria-hidden="true" />
            {{ category.configured ? "Configured" : "Setup" }}
          </span>
        </div>
        <div class="org-settings-hub__tile-body">
          <span class="org-settings-hub__tile-title">{{ category.title }}</span>
          <span class="org-settings-hub__tile-desc">{{ category.description }}</span>
        </div>
        <v-icon
          class="org-settings-hub__tile-chevron"
          icon="mdi-chevron-right"
          size="18"
        />
      </button>
    </div>

    <div v-else class="org-settings-hub__empty">
      <v-icon icon="mdi-magnify-close" size="28" color="var(--sw-muted)" />
      <span>No settings found</span>
    </div>
  </div>
</template>

<script>
import SwSearchField from "@/components/Extras/SwSearchField.vue";
import { filterOrganizationCategories } from "@/constants/organizationSettingsNav.js";

export default {
  name: "OrgSettingsHubPanel",
  components: { SwSearchField },
  props: {
    search: { type: String, default: "" },
    categories: { type: Array, default: () => [] },
    activeId: { type: String, default: "" },
    variant: {
      type: String,
      default: "page",
      validator: (v) => ["page", "dropdown"].includes(v),
    },
    title: { type: String, default: "Organization Settings" },
    subtitle: { type: String, default: "" },
    showStatusChips: { type: Boolean, default: null },
  },
  emits: ["update:search", "select"],
  computed: {
    resolvedShowStatusChips() {
      if (this.showStatusChips !== null) return this.showStatusChips;
      return this.variant === "page";
    },
    filteredCategories() {
      return filterOrganizationCategories(this.categories, this.search);
    },
  },
};
</script>
